import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.scss']
})
export class SuccessStoriesComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  RedirectToSubStories(redirection){
    this.router.navigate([redirection]);
  }

}
